import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/domains/auth';
import { navigateTo } from '@/shared/utils/navigation';
import { LoginCard } from './components/LoginCard/LoginCard';
import './LoginPage.css';

export function LoginPage() {
  const {
    isAuthenticated,
    isLoading,
    error,
    login,
    signup,
    loginWithOAuth,
    clearError,
  } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigateTo('/');
    }
  }, [isAuthenticated]);

  const handleLogin = async (credentials) => {
    const res = await login(credentials);
    if (res.success) {
      navigateTo('/');
    }
  };

  const handleSignup = async (credentials) => {
    const res = await signup(credentials);
    if (res.success) {
      navigateTo('/');
    }
  };

  const handleOAuthLogin = async (provider) => {
    await loginWithOAuth({ provider });
  };

  return (
    <div className="login-page">
      <div className="login-page__nav">
        <button
          type="button"
          className="login-page__back-btn"
          onClick={() => navigateTo('/')}
        >
          <ArrowLeft size={18} />
          <span>홈으로 돌아가기</span>
        </button>
      </div>

      <main className="login-page__main">
        <LoginCard
          onLogin={handleLogin}
          onSignup={handleSignup}
          onOAuthLogin={handleOAuthLogin}
          isLoading={isLoading}
          error={error}
          clearError={clearError}
        />
      </main>
    </div>
  );
}

export default LoginPage;
